export default __webpack_public_path__ + "static/media/sponsor_titan.f823f579.png";